import { render, staticRenderFns } from "./BullVaccination.vue?vue&type=template&id=53b39c2a&scoped=true&"
import script from "./BullVaccination.vue?vue&type=script&lang=js&"
export * from "./BullVaccination.vue?vue&type=script&lang=js&"
import style0 from "./BullVaccination.vue?vue&type=style&index=0&id=53b39c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b39c2a",
  null
  
)

export default component.exports